/**
 * 価格表示のフォーマット(小数第2位まで、値が無ければ'-')。
 * QuotationDetail/DraftQuotation/PriceShowMedicineRow/MedicineList(薬価表示)で
 * 個別に重複していた同一ロジックを共通化した。
 */
export const formatPrice = (value: number | null | undefined): string => {
  if (value == null) {
    return '-';
  }
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
